"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getForAuthor = exports.authorsSearch = exports.createDbWorker = void 0;
const Comlink = __importStar(require("comlink"));
const sqlite_worker_1 = __importDefault(require("./sqlite.worker"));
const util_1 = require("./util");
Comlink.transferHandlers.set("WORKERSQLPROXIES", {
    canHandle: (obj) => false,
    serialize(obj) {
        const { port1, port2 } = new MessageChannel();
        Comlink.expose(obj, port1);
        return [port2, [port2]];
    },
    deserialize: (port) => {
        port.start();
        return Comlink.wrap(port);
    },
});
async function createDbWorker() {
    const sqlite = Comlink.wrap(new sqlite_worker_1.default());
    const chunkSize = 4096;
    const configUrl = new URL("data/config.json", location.href);
    const config = await fetch(configUrl.toString()).then(e => e.json());
    const db = await sqlite.SplitFileHttpDatabase({
        ...config,
        urlPrefix: new URL(config.urlPrefix, configUrl).toString(),
    });
    const pageSizeResp = await db.exec("pragma page_size");
    const pageSize = pageSizeResp[0].values[0][0];
    if (pageSize !== chunkSize)
        console.warn(`Chunk size does not match page size: pragma page_size = ${pageSize} but chunkSize = ${chunkSize}`);
    return { config, worker: sqlite, db };
}
exports.createDbWorker = createDbWorker;
async function testLoop(metaDb) {
    const uploader = "Adam Ragusea";
    const videos = await metaDb.prepare("select * from videoData where author = ? limit 20");
    await videos.bind2([uploader]);
    // const res = await videos.bind([uploader]);
    // console.log("bind res", res);
    while (await videos.step()) {
        console.log("got", await videos.get());
    }
    return;
}
async function go() {
    Object.assign(window, { s: sqlite });
    await getForVideos(await createDbWorker(), "Adam Ragusea");
}
function toObjects(res) {
    const r = res[0];
    if (!r)
        return [];
    return r.values.map((v) => {
        const o = {};
        for (let i = 0; i < r.columns.length; i++) {
            o[r.columns[i]] = v[i];
        }
        return o;
    });
}
async function authorsSearch(db, author) {
    try {
        const query_inner = author
            .split(" ")
            .map((n) => n.replace(/"/g, ""))
            .map((e) => `"${e}"*`)
            .join(" ");
        const query = `NEAR(${query_inner})`;
        const sql_query = `select name from authors_search where name match ? limit 20`;
        console.log("executing search query", query, sql_query);
        const ret = toObjects(await db.exec(sql_query, [query]));
        return ret;
    }
    catch (e) {
        console.error("authorsSearch", e);
        throw e;
    }
}
exports.authorsSearch = authorsSearch;
async function getForAuthor(db, author) {
    /*await db.exec(`select s.rowid from sponsorTimes s
    join videoData v on s.videoid = v.videoid
    
    where v.author = 'Adam Ragusea'`);*/
    const videos = toObjects(await db.exec("select * from videoData where author = ? order by published asc", [author]));
    console.log("videos", videos);
    const sponsorTimes = toObjects(await db.exec(
    // "select videoData.videoID, published, lengthSeconds, title from videoData join sponsorTimes on sponsorTimes.videoID = videoData.videoID where author = ? order by sponsorTimes.rowid asc",
    // [author]
    "select * from sponsorTimes where authorID = (select id from authors where name = ?) and not shadowHidden and category = 'sponsor' order by videoID, startTime", [author])); // select sponsorTimes.rowid, sponsorTimes.videoID from videoData join sponsorTimes on sponsorTimes.videoID = videoData.videoID where author = 'Adam Ragusea';
    console.log("sponsorTimes", sponsorTimes);
    const videoMap = new Map();
    for (const video of videos) {
        videoMap.set(video.videoID, { meta: video, segments: [] });
    }
    for (const segment of sponsorTimes) {
        const tgt = videoMap.get(segment.videoID);
        if (!tgt) {
            console.warn("no metadata for video", segment.videoID);
            continue;
        }
        tgt.segments.push(segment);
    }
    //const videos = [{videoID: "gOQNRvJbpmk", lengthSeconds :  1000}];
    const out = [];
    for (const [_, video] of videoMap) {
        const sponsorTimes = video.segments;
        const segments = (0, util_1.chooseSegments)(sponsorTimes.filter((s) => s.votes > -1));
        const duration = segments
            .map((m) => m.endTime - m.startTime)
            .reduce((a, b) => a + b, 0);
        const total = video.meta.lengthSeconds;
        const percentSponsor = (duration / total) * 100;
        out.push({
            meta: video.meta,
            durationSponsor: duration,
            percentSponsor,
        });
    }
    return out;
}
exports.getForAuthor = getForAuthor;
